import { render, staticRenderFns } from "./AvatarMonthEmployee.vue?vue&type=template&id=7976c3e4"
import script from "./AvatarMonthEmployee.vue?vue&type=script&lang=js"
export * from "./AvatarMonthEmployee.vue?vue&type=script&lang=js"
import style0 from "./AvatarMonthEmployee.vue?vue&type=style&index=0&id=7976c3e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports